//This will be the dropdown item you see on the schedule page.  You can choose from
//either a league or a team to view a desired schedule
import React, { useState, useEffect } from 'react'
import Card from './Card'
import { useNavigate, useParams } from 'react-router-dom'

const FilterByTeam = (props) => {
	const [isLoading, setIsLoading] = useState(false)
	const [loadedTeams, setLoadedTeams] = useState()
	const [leagueName, setLeagueName] = useState()
	const [session, setSession] = useState()
	const [year, setYear] = useState()
	const [error, setError] = useState()

	const leagueId = useParams().leagueId || props.leagueId

	let selectedTeam
	//
	//
	//
	//Make backend call to getTeamsInLeagueByLeagueId
	useEffect(() => {
		const getTeamsInLeague = async () => {
			console.log('inside getTeamsInLeague for ' + leagueId)
			setIsLoading(true)
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/admin/${leagueId}/teams`
					//process.env.REACT_APP_BACKEND_URL + '/league/allCurrentTeams'
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				//console.log('listOfTeams: ' + JSON.stringify(responseData))
				console.log('leagueName: ' + responseData.leagueName)

				setLoadedTeams(responseData.listOfTeams)
				setLeagueName(responseData.leagueName)
				setSession(responseData.session)
				setYear(responseData.year)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		getTeamsInLeague()
	}, [setLoadedTeams])
	//
	//
	//
	//
	//
	let teamArray

	if (loadedTeams && !isLoading) {
		teamArray = []
		loadedTeams.forEach((team) => {
			//const teamDisplay = team
			teamArray.push(team)
		})
	}

	//console.log('teamArray: ' + JSON.stringify(teamArray))

	let navigate = useNavigate()

	//For handling a search by TEAM request
	const handleChange2 = (e) => {
		e.preventDefault()
		const selectedValue = e.target.value
		//console.log('selectedValue: ' + selectedValue)
		selectedTeam = loadedTeams[selectedValue]
		//console.log('selectedTeam: ' + JSON.stringify(selectedTeam))
		const teamId = selectedTeam._id
		const teamName = selectedTeam.teamName
		//navigate(`/league/schedule/${teamId}`)
		navigate(`/league/schedule/${leagueName}/${session}/${year}/${teamName}`)
	}

	return (
		<React.Fragment>
			<div className='searchbyleagueorvenue'>
				<div className='row'>
					<div className='LTVinstructions'>Filter by Team: </div>
				</div>
				{!isLoading && loadedTeams && (
					<div className='row'>
						<form className='dropdownForm'>
							<select className='scheduleselector' onChange={handleChange2}>
								<option defaultValue>Team....</option>
								{teamArray.map((team, i) => (
									<option value={i} key={i}>
										{team.teamName}
									</option>
								))}
							</select>
						</form>
					</div>
				)}
			</div>
		</React.Fragment>
	)
}

export default FilterByTeam
